import { MouseEvent, useState } from 'react';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import TurnLeftIcon from '@mui/icons-material/TurnLeft';
import { Typography } from '@mui/material';
import { DotsWrapper, RouteDetailsBlock, Wrapper } from '@styles/Admin-tools/Workflows/WorkflowStepStyles';
import { requestDeleteStep } from '../../requests';
import { TStepProps } from '../../types';
import Menu from './Menu/Menu';

const Step = ({
  handleEditStep,
  handleAddStep,
  stepData,
  handleEditParentStep,
  handleOnStepClick,
  isChecked,
}: TStepProps) => {
  const [subprimeAnchorEl, setSubprimeAnchorEl] = useState<null | HTMLElement>(null);

  const handleDotsClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setSubprimeAnchorEl(event.currentTarget);
  };

  return (
    <Wrapper stepData={stepData} isChecked={isChecked} onClick={() => handleOnStepClick(stepData.name || '')}>
      <Typography> {`${stepData?.name} (${stepData?.numericId})`}</Typography>

      {stepData?.reRouteDetails && (
        <RouteDetailsBlock type={stepData.stepType}>
          <TurnLeftIcon />
          {stepData.reRouteDetails.workflowName} {'=>'} {stepData.reRouteDetails.stepName}
        </RouteDetailsBlock>
      )}

      <DotsWrapper onClick={handleDotsClick}>
        <MoreHorizIcon />
      </DotsWrapper>

      {subprimeAnchorEl && (
        <Menu
          subprimeAnchorEl={subprimeAnchorEl}
          handleAddSubStepClick={() => handleAddStep(stepData?.id)}
          handleEditParentStepClick={() => handleEditParentStep(stepData.id, stepData.parentWorkflowStepId)}
          handleEditStepClick={() => handleEditStep(stepData)}
          handleDeleteStepClick={() => requestDeleteStep(stepData.id)}
          onClose={() => setSubprimeAnchorEl(null)}
        />
      )}
    </Wrapper>
  );
};

export default Step;
